import { ChevronDown } from "lucide-react";
import { BRANDS } from "@/lib/vehicles";
import { useLang } from "@/i18n";

const selectCls =
  "w-full appearance-none rounded-xl border border-slate-700/80 bg-slate-900/70 px-4 py-3.5 pr-10 text-sm text-slate-100 outline-none transition-colors focus:border-sky-400/70 focus:ring-2 focus:ring-sky-500/20 disabled:cursor-not-allowed disabled:opacity-40";

const SelectWrap = ({ children }) => (
  <div className="relative">
    {children}
    <ChevronDown size={16} className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-slate-500" />
  </div>
);

export const VehicleSelector = ({ value, onChange }) => {
  const { t } = useLang();
  const brand = BRANDS.find((b) => b.name === value.marque);
  const years = Array.from({ length: 12 }, (_, i) => String(2026 - i));

  return (
    <div className="grid gap-3 sm:grid-cols-3" data-testid="vehicle-selector">
      <SelectWrap>
        <select
          data-testid="vehicle-select-marque"
          aria-label={t("vehicle.brand")}
          value={value.marque}
          onChange={(e) => onChange({ marque: e.target.value, modele: "", annee: value.annee })}
          className={selectCls}
        >
          <option value="">{t("vehicle.brand")}</option>
          {BRANDS.map((b) => (
            <option key={b.name} value={b.name}>{b.name}</option>
          ))}
        </select>
      </SelectWrap>
      <SelectWrap>
        <select
          data-testid="vehicle-select-modele"
          aria-label={t("vehicle.model")}
          value={value.modele}
          disabled={!brand}
          onChange={(e) => onChange({ ...value, modele: e.target.value })}
          className={selectCls}
        >
          <option value="">{brand ? t("vehicle.model") : t("vehicle.modelFirst")}</option>
          {(brand?.models || []).map((m) => (
            <option key={m.name} value={m.name}>{m.name}</option>
          ))}
        </select>
      </SelectWrap>
      <SelectWrap>
        <select
          data-testid="vehicle-select-annee"
          aria-label={t("vehicle.year")}
          value={value.annee}
          onChange={(e) => onChange({ ...value, annee: e.target.value })}
          className={selectCls}
        >
          <option value="">{t("vehicle.year")}</option>
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </SelectWrap>
    </div>
  );
};
